import investmentDisclaimerLang from '../langs/investmentDisclaimerLang';
import { useTranslation } from 'react-i18next';
import React from 'react';
import CAppInfoTooltip from '../../../app/components/CAppInfoTooltip';

const CInfoKpi = () => {
	const { t } = useTranslation();
	return (
		<span style={{ margin: '0px 5px', position: 'relative', top: '2px' }}>
			<CAppInfoTooltip forme="triangle" title={t(investmentDisclaimerLang.kpi_warning.tag)} />
		</span>
	);
};

export default CInfoKpi;
